import { render, staticRenderFns } from "./QuickItem.vue?vue&type=template&id=82604732&scoped=true&"
import script from "./QuickItem.vue?vue&type=script&lang=js&"
export * from "./QuickItem.vue?vue&type=script&lang=js&"
import style0 from "./QuickItem.vue?vue&type=style&index=0&id=82604732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82604732",
  null
  
)

export default component.exports